import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const AllToTripsPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'oklch(97% 0.018 230.318)',
      100: 'oklch(94% 0.035 230.318)',
      200: 'oklch(90% 0.06 230.318)',
      300: 'oklch(86% 0.085 230.318)',
      400: 'oklch(82.8% 0.111 230.318)',
      500: 'oklch(76% 0.13 230.318)',
      600: 'oklch(69% 0.145 230.318)',
      700: 'oklch(61% 0.14 230.318)',
      800: 'oklch(52% 0.115 230.318)',
      900: 'oklch(43% 0.09 230.318)',
      950: 'oklch(31% 0.06 230.318)',
    },
  },
});
